import * as React from 'react'
import styled from '../../../common/src/components/styled'
import { Colors, Fonts } from '../../../common/src/constants'
import { FetchAgentVirtualTourQuery } from '../../../common/src/types.gen'

interface NextVirtualAppointmentInfoDescriptionAttendeesProps {
  showingContactsPlanningToAttend: NonNullable<
    NonNullable<FetchAgentVirtualTourQuery['agentVirtualTour']>['showing']
  >['showingContactsPlanningToAttend']
}

const Root = styled.div({
  fontSize: 16,
  color: Colors.black,
  fontFamily: Fonts.sansHeader,
})

const FirstName = styled.span({
  fontWeight: 'bold',
})

const NextVirtualAppointmentInfoDescriptionAttendees = (props: NextVirtualAppointmentInfoDescriptionAttendeesProps) => {
  const { showingContactsPlanningToAttend } = props

  const prospectShowingContacts = showingContactsPlanningToAttend.filter(sc => !sc.isAgent)

  if (prospectShowingContacts.length === 0) {
    return <Root>0 PROSPECTS</Root>
  }

  const firstShowingContacts = prospectShowingContacts[0]
  const restShowingContacts = prospectShowingContacts.slice(1)

  const { contact } = firstShowingContacts
  const { firstName, lastName } = contact

  return (
    <Root>
      <FirstName>{firstName || 'unknown'}</FirstName> {lastName || 'unknown'}
      {restShowingContacts.length > 0 &&
        ` + ${restShowingContacts.length} other${restShowingContacts.length > 1 ? 's' : ''}`}
    </Root>
  )
}

export default NextVirtualAppointmentInfoDescriptionAttendees
